module.exports = __webpack_public_path__ + "static/img/119_TO8_1654.105bd6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/119_TO8_1654.jpg
// module id = oTJ+
// module chunks = 0